/**
 * Доступ к продуктовым страницам (поиск, списки, избранное).
 * Источник истины — поля из GET /api/profile/ и /api/billing/wallet/.
 */

export function canUseProduct(userLike) {
  if (!userLike) return false
  if (userLike.is_staff) return true
  if (userLike.can_use_product === true) return true
  if (userLike.can_use_product === false) return false
  if (userLike.has_subscription) return true
  if (userLike.trial_expired === true) return false
  const ends = userLike.trial_ends_at
  if (!ends) return false
  const t = new Date(ends).getTime()
  return Number.isFinite(t) && t > Date.now()
}

export function isTrialExpired(userLike) {
  if (!userLike || userLike.is_staff) return false
  if (userLike.has_subscription) return false
  if (userLike.trial_expired === true) return true
  if (userLike.trial_expired === false) return false
  const ends = userLike.trial_ends_at
  if (!ends) return Boolean(userLike.email_verified)
  return new Date(ends).getTime() <= Date.now()
}

export function trialEndsAt(userLike) {
  return userLike?.trial_ends_at ?? null
}

export function trialDaysLeft(userLike) {
  const ends = trialEndsAt(userLike)
  if (!ends) return null
  const ms = new Date(ends).getTime() - Date.now()
  if (ms <= 0) return 0
  return Math.ceil(ms / (24 * 60 * 60 * 1000))
}
